import { UserCredentials } from '@botpress/webchat-client'
import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { StorageLocation } from '../types'

export type WebchatClientState = {
  user?: UserCredentials
  conversationId?: string
}

type WebchatClientActions = {
  setUser: (userId?: UserCredentials) => void
  setConversationId: (conversationId?: string) => void
  clearAll: () => void
}

type WebchatClientStore = WebchatClientState & WebchatClientActions

const createWebchatClientStore = (storeName: string, storageLocation?: StorageLocation) =>
  create<WebchatClientStore>()(
    devtools(
      persist(
        (set) => ({
          setUser: (user) =>
            set((state) => ({
              ...state,
              user,
            })),
          setConversationId: (conversationId) =>
            set((state) => ({
              ...state,
              conversationId,
            })),
          clearAll: () => {
            set((state) => ({
              ...state,
              user: undefined,
              conversationId: undefined,
            }))
          },
        }),
        {
          name: storeName,
          storage: createJSONStorage(() => (storageLocation === 'sessionStorage' ? sessionStorage : localStorage)),
        }
      )
    )
  )
type BoundWebchatClientStore = ReturnType<typeof createWebchatClientStore>

const webchatClientStoreInstances: { [key: string]: BoundWebchatClientStore } = {}

export const getUseWebchatClientStore = (
  name = 'bp-webchat',
  storageLocation?: StorageLocation
): BoundWebchatClientStore => {
  const storeKey = `${name}-client`

  if (!webchatClientStoreInstances[storeKey]) {
    webchatClientStoreInstances[storeKey] = createWebchatClientStore(storeKey, storageLocation)
  }
  return webchatClientStoreInstances[storeKey]
}
